module.exports = "./assets/assets/意向公示模板.93cf1d7e.docx";